<script>
    import Datepicker from 'vuejs-datepicker';
    import moment from 'moment';
    export default {
        props: ['lang_strings'],
        components: {
            Datepicker
        },
        data() {
            return {
                lang: 'en',
                success: false,
                step: 1,
                total_steps: 4,
                first_time : '',
                travel_type : '',
                duration : [],
                arrival_date : '',
                arrival_date_not_sure : false,
                departure_date : '',
                departure_date_not_sure : false,
                prefered_date : '',
                prefered_date_not_sure: false,
                prefered_language : '',
                adults_count : 1,
                kids_count : 0,
                infants_count : 0,
                transfer : '',
                accomondation_type : '',
                accommodation__exists: '',
                interests_nature : '',
                interests_fooddrink : '',
                interests_nightlife : '',
                interests_seasun : '',
                interests_shopping : '',
                interests_architecture : '',
                interests_folklore : '',
                interests_archeology : '',
                interests_artsevents : '',
                mood : [],
                budget : '',
                how_active : '',
                first_name : '',
                last_name : '',
                email : '',
                phone_number : '',
                age : '',
                country : '',
                loading: false,
                form_errors: '',
                start_date: moment().add(11, 'days').toDate(),
                disabledDates: { 
                    to: moment().toDate(),
                }
            }
        },
        mounted() {
            this.lang = document.documentElement.lang;
            moment.locale(this.lang);
        },
        methods: {
            nextStep() {
                if(this.step <= this.total_steps){
                    this.step++;
                    $("html, body").animate({ scrollTop: $('#tailormade__form').offset().top - 80 }, 500);
                }
            },
            goBack(){
                if(this.step > 1){
                    this.step--;
                    $("html, body").animate({ scrollTop: $('#tailormade__form').offset().top - 80 }, 500);
                }
            },
            goToStep(step) {
                if(step > this.step){
                    this.$validator.validateAll('step'+this.step).then(result => {
                        if(result) {
                            for(var i=1; i<step; i++) {
                                this.$validator.validateAll('step'+i).then(result => {
                                    if (result) this.step = step;
                                });
                            }
                        }
                    })
                } else {
                    this.step = step;
                }
            },
            submitForm(scope) {
                this.$validator.validateAll(scope).then(result => {
                    if (result) {
                        this.nextStep();
                    }
                });
            },
            sendForm() {
                this.loading = true;
                axios.post('/tailor-made', this.$data, {
                    headers: {
                        'Content-Type': 'application/json'
                    },
                })
                .then( response => {
                    this.loading = false;
                    this.success = true;
                    this.$nextTick(() => {
                        $("html, body").animate({ scrollTop: $('.tailormade__form__success').offset().top - 80 }, 500);
                    });
                    this.$ga.event({
                        eventCategory: 'Tailor made',
                        eventAction: 'New Request',
                        eventLabel: 'Success',
                        eventValue: 1
                    });
                })  
                .catch( e => { 
                    this.loading = false;
                    console.log(e.response.data);
                    if(e.response.data.errors) {
                        this.form_errors = e.response.data.errors
                    }
                });
            }
        },
        filters: {
            formatDate: function (value) {
                if (!value) return ''
                return moment(String(value)).format('dddd, MMMM D, YYYY')
            },
            preferences: (value, lang_strings) => {
                switch(value) {
                case "1":
                    return lang_strings['why_not']
                    break;
                case "2":
                    return lang_strings['yes_please']
                    break;
                case "3":
                    return lang_strings['we_love_this']
                    break;
                default:
                    return ""
                }
            },
            active: (value, lang_strings) => {
                switch(value) {
                case "1":
                    return lang_strings['lazy']
                    break;
                case "2":
                    return lang_strings['normal']
                    break;
                case "3":
                    return lang_strings['hyperactive']
                    break;
                default:
                    return ""
                }
            },
            budget: (value, lang_strings) => {
                switch(value) {
                case "1":
                    return lang_strings['tight']
                    break;
                case "2":
                    return lang_strings['normal']
                    break;
                case "3":
                    return lang_strings['large']
                    break;
                default:
                    return ""
                }
            },
        }
    }
</script>
